import React, { useState } from 'react';
import { Container, Typography, Box, Card, CardContent, TextField, Button, Alert, Grid } from '@mui/material';
import CustomerLayout from '../../components/customer/CustomerLayout';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import customerApiService from '../../services/customerApi';
import { EndUserUpdate } from '../../types/endUser';

const CustomerProfilePage: React.FC = () => {
  // readOnly = impersonación «viendo como cliente»: sin escrituras.
  const { user, readOnly } = useCustomerAuth();
  const [formData, setFormData] = useState<EndUserUpdate>({
    full_name: user?.full_name || '',
    phone: user?.phone || '',
    company: user?.company || ''
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    try {
      await customerApiService.updateMe(formData);
      setSuccess(true);
    } catch (err: any) {
      setError('Failed to update profile');
    }
  };

  return (
    <CustomerLayout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          My Profile
        </Typography>

        {success && <Alert severity="success" sx={{ mb: 3 }}>Profile updated successfully</Alert>}
        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

        <Card>
          <CardContent>
            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField fullWidth label="Email" value={user?.email} disabled />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Full Name" name="full_name" value={formData.full_name} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Phone" name="phone" value={formData.phone} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Company" name="company" value={formData.company} onChange={handleChange} />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" size="large" disabled={readOnly}>
                    Save Changes
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </CustomerLayout>
  );
};

export default CustomerProfilePage;

